import $ from 'jquery'
import purify from './purify'

function addNotification(ultype, altype, what) {
  console.log(ultype + ':' + what)
  var a = $('.notification_pane>div.' + ultype, document)

  if (a.length === 0) {
    console.log('not existing notification pane for ' + ultype)
    var div = '<div class="' + ultype + ' alert alert-' + altype +
      ' alert-dismissible fade in" role="alert">' +
      '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
      '<span aria-hidden="true">&times;</span></button>' +
      '<ul>' +
      '</ul>' +
      '</div>'
    $('.notification_pane', document).append($(div))
    a = $('.notification_pane>div.' + ultype, document)
  }

  var b = $('ul', a)
  var msg = '<li>' + what + '</li>'
  msg = purify.block(msg)
  b.append(msg)

  $('.close', a).click(function () {
    a.remove()
  })

  if (ultype == 'messages') {
    a.delay(7000).fadeOut('slow', function () {
      $(this).remove()
    })
  }
}

function addError(what) {
  addNotification('errors', 'danger', what)
}

function addWarning(what) {
  addNotification('warnings', 'warning', what)
}

function addMessage(what) {
  addNotification('messages', 'success', what)
}

function clearNotifications() {
  console.log('clearNotifications')
  $('.notification_pane').empty()
  $('.has-error').removeClass('has-error')
  $('.has-feedback').removeClass('has-feedback')
  $('.autonod_error').remove()
}

var notify = {
  error: addError,
  warning: addWarning,
  message: addMessage,
  clear: clearNotifications,
}

export { notify as default }
